<template>
  <div class="homepage-search-vehicle__filters-section">
    <div class="form-input__input-with-icon homepage-search-vehicle__filters-section-content">
      <input
        class="form-input form-input__form-control form-input__input-primary-inverted"
        type="text"
        name="location"
        placeholder="Postcode/Town"
        data-location-element="true"
        data-customer-location="true"
        autocomplete="off"
        ref="input"
        :value="location.location"
      />

      <button type="button" class="form-input__icon-button" @click="lookupLocation">
        <img width="18" height="18" src="/images/location-point.svg" alt="Location" />
      </button>
    </div>
  </div>
</template>


<script>
    import { defineComponent } from "vue";
    import { mapGetters, mapState } from 'vuex'

    export default defineComponent({
        name: 'Location',

        data() {
            return {
                locationAllowed: true,
                autocomplete: false,
                googleClass: false,
            }
        },

        computed: {
            ...mapGetters({
                geoLocation: 'Dealers/geoLocation',
                userOptions: 'UsedSearchOptions/userOptions',
            }),
            ...mapState('SearchOptions', {
                location: 'location'
            })
        },
        methods: {
            lookupLocation() {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                    this.$store.commit('SearchOptions/setLocation', {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    });
                    this.$store.commit('Dealers/setGeoLocation', position);
                    this.$store.dispatch('Dealers/setDistances')
                    .then(() => {
                        this.$emit('changed', false);
                    });
                },
                (error) =>{
                    this.locationAllowed = false;
                });
            }
        },
        mounted() {
            GoogleMapsLoader.getMap().then(googleClass => {
                if (!this.$refs['input']) {
                    return;
                }
                this.googleClass = googleClass;
                this.autocomplete = new googleClass.maps.places.Autocomplete(this.$refs['input']);
                this.autocomplete.setComponentRestrictions({'country': ['gb']});
                this.autocomplete.setFields(['geometry', 'place_id', 'name']);
                this.autocomplete.addListener('place_changed', () => {
                    const place = this.autocomplete.getPlace();
                    this.$store.commit('Dealers/setLocation', {
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                        locationString: place.name,
                    });
                    this.$store.commit('SearchOptions/setLocation', {
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                        location: this.$refs['input'].value
                    });
                    this.$store.dispatch('Dealers/setDistances')
                    .then(() => {
                        this.$emit('changed', false);
                    });
                });
            });
        },
        beforeDestroy() {
            if (this.autocomplete && this.googleClass && this.$refs['input']) {
                this.googleClass.maps.event.clearInstanceListeners(this.$refs['input']);
                this.autocomplete.unbindAll();
            }
        },
    })
</script>